import { Link } from "react-router-dom";
import { RotateCcw, Truck, Sparkles } from "lucide-react";
import Seo from "../components/site/Seo";
import { PageHero, Section, Timeline, CtaBand, Disclaimer } from "../components/site/Bits";
import { TRIAL_STEPS } from "../components/site/data";

const INFO = [
  { icon: RotateCcw, title: "If the equipment isn't suitable", points: ["Tell us at any point during the trial. There's no pressure to keep anything.", "We'll collect the item and, with your therapist, look at alternatives.", "If funding isn't approved, we arrange collection at a time that suits you."] },
  { icon: Truck, title: "Delivery and collection", points: ["We deliver across Melbourne and Victoria and set the equipment up for you.", "We show you and your carers how to use it safely.", "Collection is booked at a time that suits you. You can also request it online."] },
  { icon: Sparkles, title: "Hygiene and cleaning between trials", points: ["Every item is cleaned and disinfected after each trial, following infection-control procedures.", "A safety and function inspection is completed before each re-trial.", "Cleaning and inspection records are logged against each unit's serial number."] },
];

export default function TrialsHow() {
  return (
    <>
      <Seo title="How NDIS Equipment Trials Work | Try Before You Buy" path="/equipment-trials"
        description="Our assistive technology trial-to-purchase process in Melbourne: delivery, home trial, trial report and quote for NDIS funding, then purchase or collection." />
      <PageHero eyebrow="Equipment trials" title="How equipment trials work"
        intro="Try assistive technology in your own home before it's purchased. We work with your therapist and provide the trial report and quote you need for your NDIS funding request."
        image="/images/living-wheelchair.jpg" imageAlt="A smiling woman sitting in her wheelchair in a comfortable living room">
        <Link to="/request-trial" className="btn-primary" data-testid="trials-request-btn">Request a Trial</Link>
        <Link to="/equipment" className="btn-outline" data-testid="trials-catalogue-btn">Browse equipment</Link>
      </PageHero>
      <Section id="process" eyebrow="The trial-to-purchase process" title="Six clear steps">
        <Timeline steps={TRIAL_STEPS} testid="trial-timeline" />
      </Section>
      <Section tone="bg-surface" eyebrow="Good to know" title="Trials without the worry">
        <div className="grid gap-6 lg:grid-cols-3">
          {INFO.map((b) => (
            <section key={b.title} className="card p-7" aria-labelledby={`h-${b.title}`}>
              <b.icon className="text-teal" size={30} aria-hidden="true" />
              <h3 id={`h-${b.title}`} className="mt-4 font-display text-xl font-semibold">{b.title}</h3>
              <ul className="mt-4 list-disc space-y-2 pl-5 text-ink-muted">{b.points.map((p) => <li key={p}>{p}</li>)}</ul>
            </section>
          ))}
        </div>
        <div className="mt-10"><Disclaimer /></div>
      </Section>
      <CtaBand title="Ready to try equipment at home?" />
    </>
  );
}
